import React from "react";
import {
  FormControl,
  FormLabel,
  InputAdornment,
  OutlinedInput,
  FormHelperText, // Import FormHelperText for helper text
} from "@mui/material";

const AmountInput = ({
  id,
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  helperText,
  options = {},
}) => {
  return (
    <FormControl
      fullWidth
      required={required}
      sx={{ mb: 2 }}
      error={!!helperText}
    >
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <OutlinedInput
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        startAdornment={<InputAdornment position="start">₹</InputAdornment>}
        {...options}
        type="number"
      />
      {/* Render the helperText below the OutlinedInput */}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default AmountInput;
